// Ensure Node-style globals exist in the browser for wallet/crypto libs
// (WalletConnect, viem deps, etc.) that assume Buffer/global/process.
import { Buffer as BufferPolyfill } from "buffer";

type BrowserProcess = {
  env: Record<string, string | undefined>;
  browser: true;
  version: string;
  nextTick: (callback: (...args: unknown[]) => void, ...args: unknown[]) => void;
};

const g = globalThis as unknown as {
  Buffer?: typeof BufferPolyfill;
  global?: typeof globalThis;
  process?: Partial<BrowserProcess>;
};

if (typeof g.Buffer === "undefined") {
  g.Buffer = BufferPolyfill;
}
if (typeof g.global === "undefined") {
  g.global = globalThis;
}
if (typeof g.process === "undefined") {
  g.process = {
    env: {},
    browser: true,
    version: "",
    nextTick: (callback, ...args) => queueMicrotask(() => callback(...args)),
  };
} else {
  g.process.env ??= {};
  g.process.browser = true;
}

export {};
